import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { StorageService } from 'src/app/services/storage.service';

import { RichTextEditorService } from '../../services/rich-text-editor.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { LoadingModalService } from 'src/app/services/loadingmodal.service';
import { combineLatest, Observable } from 'rxjs';


@Component({
  selector: 'app-admin-government-detail',
  templateUrl: './admin-government-detail.component.html',
  styleUrls: ['./admin-government-detail.component.sass']
})

export class AdminGovernmentDetailComponent implements OnInit {
  uid;

  // dateToday = new Date()
  // date2digits(date){
  //   return (date < 10 ? '0' : '') + date
  // }
  // dateYear = this.date2digits(this.dateToday.getFullYear())
  // dateMonth = this.date2digits(this.dateToday.getMonth()+1)
  // dateDate = this.date2digits(this.dateToday.getDate())
  // dateHours = this.date2digits(this.dateToday.getHours())
  // dateMinutes = this.date2digits(this.dateToday.getMinutes())
  // dateSeconds = this.date2digits(this.dateToday.getSeconds())
  // dateMillisecounds = this.date2digits(this.dateToday.getMilliseconds())
  // dateFileName = `${this.dateYear}${this.dateMonth}${this.dateDate}-${this.dateHours}${this.dateMinutes}${this.dateSeconds}`

  governmentDocId;
  governmentDoc;
  governmentCategoryCol;

  coverPicture: string = "./assets/img/no-cover.png";
  profilePicture: string = "./assets/img/no-logo.png";
  profilePictureCol;
  coverPictureCol;

  // Upload Picture File
  pictureUpload;
  activeProfilePictureUrl;

  //Forms
  updateAboutForm;
  updateContactForm;
  addLocationForm: FormGroup;
  updateLocationForm;
  addProductForm: FormGroup;
  updateProductForm;
  addTeamForm: FormGroup;
  updateTeamForm;
  addJobForm: FormGroup;
  updateJobForm; 

  text: string = '';
  editorConfig: AngularEditorConfig;
  //uploadProgress: number = 0;

  profilePictureColDocLenght;
  coverPictureColDocLenght;
  publicationColDocLenght;
  mediaReleaseColDocLenght;
  speechColDocLenght;
  peopleColDocLenght;
  locationColDocLenght;

  uploadProgress;
  //fileSrcPDF;
  //fileSrcPicture;
  //textareaContent: string = '';  
  //publicationFilePDF;
  //publicationFilePicture: string = "./assets/img/no-cover.png";  
  //publicationFilePictureObject: File | null = null;
  //publicationPicture: boolean = false;
  publicationPictureSrc: string;
  publicationPDFSrc: string = '';
  publicationPictureFile: File | null = null;
  publicationPDFFile: File | null = null;
  publicationPictureFileName: string;
  publicationPDFFileName: string;
  publicationName: string = '';
  publicationCol; 

  // mediaReleaseFilePDF;
  // mediaReleaseFilePicture: string = "./assets/img/no-cover.png";  
  // mediaReleaseFilePictureObject: File | null = null;
  // mediaReleasePicture: boolean = false;
  // mediaReleasePDFFile: File | null = null;
  // mediaReleasePDFSrc: string = '';
  mediaReleasePictureSrc: string;
  mediaReleasePictureFile: File | null = null;  
  mediaReleasePictureFileName: string;
  mediaReleaseName: string = '';
  mediaReleaseCol;

  docData: object;
  pictureSrc: string;
  pictureFile: File | null = null;
  pdfFile: File | null = null;  
  pictureFileName: string | null;
  pdfFileName: string | null;
  docName: string = '';
  content: string = '';  
  geopoint: string = '';
  postal: string = '';
  location: string = '';
  phone: string = '';
  email: string = '';
  date: string = '';
  position: string = '';
  
  speechCol;
  peopleCol;
  locationCol;

  combinedCollection: Observable<any[]>;
  postCol;

  constructor(
    private fb : FormBuilder,
    public db: FirestoreService,
    public auth: AuthenticationService,
    public storage: StorageService,
    public afAuth: AngularFireAuth,
    public afDd: AngularFirestore,
    public route: Router,
    private modalService: NgbModal,
    //config: NgbModalConfig,
    public aRoute: ActivatedRoute,

    //private elementRef: ElementRef,
    private editorService: RichTextEditorService,
    //private loadingModalService: LoadingModalService,
  ){
      this.editorConfig = editorService.editorConfig;
  }    

  ngOnInit(): void {
    
    this.auth.getPeopleSignInUid()
    .then( res=> {
      this.uid = res.uid;  
    });
    
    this.governmentDocId = this.aRoute.snapshot.paramMap.get('id')
    this.governmentDoc = this.db.getMainDoc('governments', this.governmentDocId);
    // console.log('this.docId: '+this.governmentDocId);   
    this.governmentCategoryCol = this.db.getMainCol('governmentCategories');
    this.publicationCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'publications');
    this.mediaReleaseCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'mediaReleases');
    this.speechCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'speeches');
    this.peopleCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'people');
    this.locationCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'locations');


    // this.postCol = 
    // this.combinedCollection = combineLatest([this.publicationCol, this.mediaReleaseCol]).pipe(
    //   map(([pubData, mediaData]) => {
    //     // Combine and sort documents by timestamp
    //     const combinedData = [...pubData, ...mediaData];
    //     combinedData.sort((a, b) => a.timestamp - b.timestamp);
    //     return combinedData;
    //   })
    //  );


    this.profilePictureCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'profilePictures');
    this.coverPictureCol = this.db.getSubColLimit(10, 'governments', this.governmentDocId, 'coverPictures');
    // this.db.getSubColDocLenght('governments', this.governmentDocId, 'profilePictures')
    // .snapshotChanges()
    // .subscribe(query=>{
    // this.profilePictureColDocLenght = query.length;
    // console.log(this.profilePictureColDocLenght);
    // });
    // this.db.getSubColDocLenght('governments', this.governmentDocId, 'coverPictures')
    // .snapshotChanges()
    // .subscribe(query=>{
    // this.coverPictureColDocLenght = query.length;
    // });

    // Check documents lenght
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'profilePictures')
      .then(response =>{
      this.profilePictureColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'coverPictures')
      .then(response =>{
      this.coverPictureColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'publications')
      .then(response =>{
      this.publicationColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'mediaReleases')
      .then(response =>{
      this.mediaReleaseColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'speeches')
      .then(response =>{
      this.speechColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'people')
      .then(response =>{
      this.peopleColDocLenght = response;
    });
    this.db.getSubColDocLenght('governments', this.governmentDocId, 'locations')
      .then(response =>{
      this.locationColDocLenght = response;
    });
    
    this.updateAboutForm = this.fb.group({
      name:'',
      category:'',
      about:'',      
      dateUpdated: Date.now(),
    })
    this.updateContactForm = this.fb.group({
      phone: '',
      email: '',
      websiteUrl: '',
      postal: '', 
      socialLinkedinUrl:'',
      socialWhatsappPhone:'',
      socialTwitterUrl:'',
      socialFacebookUrl:'',      
      dateUpdated: Date.now(),
    })

    this.addLocationForm = this.fb.group({
      name:'',
      address:'',
      latitude:'',
      longitude:'',
      colId: 'locations',
      dateUpdated: Date.now(),
      dateCreated: Date.now(),
      creatorUid: this.uid 
    })
    this.updateLocationForm = this.fb.group({
      name:'',
      address:'',
      latitude:'',
      longitude:'',
      dateUpdated: Date.now(),
      userUpdated: this.uid
    })
  }
    
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });    
  }

  date2digits(date){
    return (date < 10 ? '0' : '') + date
  }
  dateFileName(){
    const dateToday = new Date()  
    const dateYear = this.date2digits(dateToday.getFullYear())
    const dateMonth = this.date2digits(dateToday.getMonth()+1)
    const dateDate = this.date2digits(dateToday.getDate())
    const dateHours = this.date2digits(dateToday.getHours())
    const dateMinutes = this.date2digits(dateToday.getMinutes())
    const dateSeconds = this.date2digits(dateToday.getSeconds())
    const dateMillisecounds = this.date2digits(dateToday.getMilliseconds())
    const dateFileName = `${dateYear}${dateMonth}${dateDate}-${dateHours}${dateMinutes}${dateSeconds}`
    return dateFileName
  }
  
  openModal(content){
    this.modalService.open(content)
  }
  closeModal(){
    this.modalService.dismissAll()
    this.publicationPictureSrc = '';  
    this.publicationPDFSrc = '';  
    this.publicationPictureFileName = ''; 
    this.publicationPictureFile = null;
    this.publicationPDFFileName = '';  
    this.publicationName = '';  
    this.mediaReleasePictureSrc = '';  
    this.mediaReleasePictureFileName = ''; 
    this.mediaReleasePictureFile = null;
    this.mediaReleaseName = '';

    this.pictureSrc = ''; 
    this.pictureFile = null;
    this.pdfFile = null;
    this.pictureFileName = ''; 
    this.pdfFileName = ''; 
    this.docName = ''; 
    this.content = ''; 
    this.geopoint = ''; 
    this.postal = ''; 
    this.location = ''; 
    this.phone = ''; 
    this.email = ''; 
    this.date = ''; 
    this.position = ''; 
  }

  openSpinnerModal(content){
    this.modalService.open(content);
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 5000); 
  }

  // Text Editor
  onTextChanged(event: any) {
    // Handle text changes here
  }
  // Example usage of pastePlainText method
  onKeyDown(event: KeyboardEvent): void {
    this.editorService.handleKeyDownEvent(event);
  }
  onPaste(event: ClipboardEvent): void {
    this.editorService.handlePasteEvent(event);
  }

  // Update About
  closeUpdateAboutModalForm(){
    this.modalService.dismissAll()
    this.updateAboutForm.reset()
  }
  openUpdateAboutModalForm(content) {
    this.modalService.open(content);
  }
  updateAboutField(formValues){
    this.db.updateMainDoc(formValues, 'governments', this.governmentDocId)    
    .then(res =>{
      this.closeUpdateAboutModalForm()
    })
  }

  // Update Contact
  closeUpdateContactModalForm(){
    this.modalService.dismissAll()
    this.updateAboutForm.reset()
  }
  openUpdateContactModalForm(content) {
    this.modalService.open(content);
  }
  updateContactField(formValues){
    this.db.updateMainDoc(formValues, 'governments', this.governmentDocId)    
    .then(res =>{
      this.closeUpdateAboutModalForm()
    })
  }  

  // Profile Picture
  addProfilePictureDoc(e, spinnerModalContent){
    this.pictureUpload = e.target.files[0];
    if(this.pictureUpload != undefined){   
      // Open Modal
      this.modalService.open(spinnerModalContent);   
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'profilePictureUrl', 'pictureUrl', 'governments', this.governmentDocId, 'profilePictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
            //this.reloadComponent();
          }, 3000)          
        }
      })
      
    }

  }
  updateProfilePictureDoc(pictureUrl){
    this.db.updateMainDocField('governments', this.governmentDocId, 'profilePictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  }
  deleteProfilePictureDoc(docid, pictureUrl){
    console.log(docid);
    
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('governments', this.governmentDocId, 'profilePictures', docid);
    })
    .then(()=>{
      //this.reloadComponent();
    })
    .then(()=>{
      this.closeModal();
    })
  }
  
  // Cover Picture
  addCoverPictureDoc(e, spinnerModalContent){    
    this.pictureUpload = e.target.files[0];
    if(this.pictureUpload != undefined){
      // Open Modal
      this.modalService.open(spinnerModalContent);
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'coverPictureUrl', 'pictureUrl', 'governments', this.governmentDocId, 'coverPictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        }
      })
    }
  }
  updateCoverPictureDoc(pictureUrl){
    this.db.updateMainDocField('governments', this.governmentDocId, 'coverPictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  } 
  deleteCoverPictureDoc(docid, pictureUrl){
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('governments', this.governmentDocId, 'coverPictures', docid)
    })
    .then(()=>{
      this.closeModal();
    })
  }

  // Publication
  selectPublicationPDF(e: Event){
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.publicationPDFFile = input.files[0];
      this.publicationPDFFileName = input.files[0].name;
      const file = input.files[0];
      // Here, you can use the FileReader API to read the file data as a data URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.publicationPDFSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  selectPublicationPicture(e){
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.publicationPictureFile = input.files[0];
      this.publicationPictureFileName = input.files[0].name;
      const file = input.files[0];
      // Here, you can use the FileReader API to read the file data as a data URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.publicationPictureSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  removePublicationPicture(){
    this.publicationPictureSrc = null;
    this.publicationPictureFile = null;
    this.publicationPictureFileName = null;
  }
  addPublicationDoc(spinnerModalContent){
    this.modalService.open(spinnerModalContent); 
    const docData = 
    { name: this.publicationName,
      pdfFileName: this.publicationPDFFileName,
      pictureFileName: this.publicationPictureFileName,
      postTyp: 'Publication',
      serviceId: 'Government Profile',
      colId: 'governments',
      docId: this.governmentDocId,
      publish: false,
      popular: false,
      dateCreate: Date.now(),
      dateUpdate: Date.now(),
      uidCreate: this.uid,
      uidUpdate: this.uid,
    }
    
    const generatedFileName = `pngl-img-${this.dateFileName()}`;
    this.storage.uploadPDFPicture(generatedFileName, this.publicationPDFFile, this.publicationPictureFile, docData, 'governments', this.governmentDocId, 'publications')
    .then(()=>{
      setTimeout(() => {
        this.closeModal();
      }, 3000);      
    })
    .then(()=>{
      this.publicationColDocLenght++
    })
    .catch(error=>{
      console.log(error);      
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
    .finally(()=>{     
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
  }
  updatePublicationDocPublish(publicationDocId){
    const docData = {publish: true}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, 'publications', publicationDocId)
  }
  updatePublicationDocUnpublish(publicationDocId){
    const docData = {publish: false}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, 'publications', publicationDocId)
  }
  deletePublicationDoc(docId, fileUrl, pictureUrl){
    this.storage.deletePDFPicture(fileUrl, pictureUrl, 'governments', this.governmentDocId, 'publications', docId)
    .then(res =>{
      this.closeModal();
    })
    .then(()=>{});
  }

  // Media Release
  selectMediaReleasePicture(e){
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.mediaReleasePictureFile = input.files[0];
      this.mediaReleasePictureFileName = input.files[0].name;
      const file = input.files[0];
      // Here, you can use the FileReader API to read the file data as a data URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.mediaReleasePictureSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  removeMediaReleasePicture(){
    this.mediaReleasePictureSrc = null;
    this.mediaReleasePictureFile = null;
    this.mediaReleasePictureFileName = null;
  }
  addMediaReleaseDoc(spinnerModalContent){
    this.modalService.open(spinnerModalContent); 
    const docData = 
    { name: this.mediaReleaseName,
      pictureFileName: this.mediaReleasePictureFileName,
      postTyp: 'Media Release',
      serviceId: 'Government Profile',
      colId: 'governments',
      docId: this.governmentDocId,
      publish: false,
      popular: false,
      dateCreate: Date.now(),
      dateUpdate: Date.now(),
      uidCreate: this.uid,
      uidUpdate: this.uid,
    }
    const generatedFileName = `pngl-img-${this.dateFileName()}`;
    this.storage.uploadPicture(generatedFileName, this.mediaReleasePictureFile, docData, 'governments', this.governmentDocId, 'mediaReleases')
    .then(()=>{
      setTimeout(() => {
        this.closeModal();
      }, 3000);      
    })
    .then(()=>{
      this.mediaReleaseColDocLenght = 1
    })
    .catch(error=>{
      console.log(error);      
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
    .finally(()=>{     
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
  }
  updateMediaReleaseDocPublish(mediaReleaseDocId){
    const docData = {publish: true}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, 'mediaReleases', mediaReleaseDocId)
  }
  updateMediaReleaseDocUnpublish(mediaReleaseDocId){
    const docData = {publish: false}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, 'mediaReleases', mediaReleaseDocId)
  }
  deleteMediaReleaseDoc(docId, fileUrl, pictureUrl){
    this.storage.deletePicture(pictureUrl, 'governments', this.governmentDocId, 'mediaReleases', docId)
    .then(res =>{
      this.closeModal();
    })
    .then(()=>{});
  }

  // Speech
  // Public Money Management Regularization Act
  selectPicture(e){
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.pictureFile = input.files[0];
      this.pictureFileName = input.files[0].name;
      const file = input.files[0];
      // Here, you can use the FileReader API to read the file data as a data URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.pictureSrc = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  removePicture(){
    this.pictureSrc = null;
    this.pictureFile = null;
    this.pictureFileName = null;
  }
  addDoc(spinnerModalContent, postType, subColId){
    this.modalService.open(spinnerModalContent); 
    const primaryDocData = 
    { 
      postTyp: postType,
      serviceId: 'Government Profile',
      colId: 'governments',
      docId: this.governmentDocId,
      publish: false,
      popular: false,
      dateCreate: Date.now(),
      dateUpdate: Date.now(),
      uidCreate: this.uid,
      uidUpdate: this.uid,
    }
    const publicationDocData = 
    { 
      pictureFileName: this.pictureFileName || null,
      pdfFileName: this.pdfFileName || null,
      name: this.docName || null,
      content: this.content || null,
    }
    const mediaReleaseDocData = 
    { 
      pictureFileName: this.pictureFileName || null,
      name: this.docName || null,
      content: this.content || null,
    }
    const speechDocData = 
    { 
      pictureFileName: this.pictureFileName || null,
      name: this.docName || null,
      content: this.content || null,      
      location: this.location || null,     
      date: this.date || null,    
      aaaa: 'speechDocData from swith'  
    }
    const peopleDocData = 
    { 
      pictureFileName: this.pictureFileName || null,
      name: this.docName || null,
      content: this.content || null,
      phone: this.phone || null,
      email: this.email || null,
      position: this.position || null,
    }
    const locationDocData = 
    { 
      pictureFileName: this.pictureFileName || null,
      name: this.docName || null,
      content: this.content || null,
      geopoint: this.geopoint || null, 
      postal: this.postal || null,
      location: this.location || null,
      phone: this.phone || null,
      email: this.email || null,     
    }

    switch (postType){        
      case 'Publication':
        this.docData = {...primaryDocData, ...publicationDocData};
        break;
      case 'Media Release':
        this.docData = {...primaryDocData, ...mediaReleaseDocData};
        break;
      case 'Speech':
        this.docData = {...primaryDocData, ...speechDocData};
        break;
      case 'People':
        this.docData = {...primaryDocData, ...peopleDocData};
        break;
      case 'Location':
        this.docData = {...primaryDocData, ...locationDocData};
        break;
    }      

    const generatedFileName = `pngl-img-${this.dateFileName()}`;
    this.storage.uploadPicture(generatedFileName, this.pictureFile, this.docData, 'governments', this.governmentDocId, subColId)
    .then(()=>{
      setTimeout(() => {
        this.closeModal();
      }, 3000);      
    })
    .then(()=>{
      switch (postType){        
        case 'Publication':
          this.publicationColDocLenght++
          break;
        case 'Media Release':
          this.mediaReleaseColDocLenght++
          break;
        case 'Speech':
          this.speechColDocLenght++
          break;
        case 'People':
          this.peopleColDocLenght++
          break;
        case 'Location':
          this.speechColDocLenght++
          break;
      }      
    })
    .catch(error=>{
      console.log(error);      
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
    .finally(()=>{     
      setTimeout(() => {
        this.closeModal();
      }, 3000);
    })
  }
  updateDocPublish(subColId, subDocId){
    const docData = {publish: true}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, subColId, subDocId);
  }
  updateDocUnpublish(subColId, subDocId){
    const docData = {publish: false}
    this.db.updateSubDoc(docData, 'governments', this.governmentDocId, subColId, subDocId);
  }
  deleteDoc(pictureUrl, postType, subColId, subDocId){
    //async deletePicture(pictureUrl, mainColId, mainDocId, subColId, subDocId){
    this.storage.deletePicture(pictureUrl, 'governments', this.governmentDocId, subColId, subDocId)
    .then(res =>{
      this.closeModal();
    })
    .then(()=>{
      switch (postType){        
        case 'Publication':
          this.publicationColDocLenght--
          break;
        case 'Media Release':
          this.speechColDocLenght--
          break;
        case 'Speech':
          this.speechColDocLenght--
          break;
        case 'People':
          this.speechColDocLenght--
          break;
        case 'Location':
          this.speechColDocLenght--
          break;
      }    
    });
  }
  
  // route
  routeToHomePage(){
    this.route.navigate(['']);
  }
  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }
  routToLogin(){
    this.db.getArrayValue('governments', this.governmentDocId, this.uid)
  }
}